import './api/add-grammar-error.js';
import './api/agents/ocr-agent.js';
import './api/agents/structure-agent.js';
import './api/beta-access-query.js';
import './api/calculate-max-points.js';
import './api/claim-guest-conversation.js';
import './api/cleanup-guest-data.js';
import './api/clear-pending-canvas-open.js';
import './api/clear-pending-download.js';
import './api/confirm-structure.js';
import './api/confirm-submission-split.js';
import './api/create-classroom.js';
import './api/create-exam.js';
import './api/create-examTask.js';
import './api/create-submission-split-confirmation.js';
import './api/create-student.js';
import './api/create-submission.js';
import './api/create-teacher.js';
import './api/decide-join-request.js';
import './api/delete-exam.js';
import './api/delete-grammar-error.js';
import './api/delete-submission.js';
import './api/dummy.js';
import './api/edit-student.js';
import './api/edit-teacher-memory.js';
import './api/edit-teacher.js';
import './api/exam-creation/exam-editor-api.js';
import './api/exam-watcher.js';
import './api/file-intake.js';
import './api/file-upload.js';
// Registers every job type (side-effect imports, like the pending-task desc builders). This is what ARMS the
// job system: until it is imported the registry is empty, so every dispatch resolves no definition and any row the
// runner claims is deferred as an unknown type. Must come before `startJobSystem()` in `server/startup.ts`, which it
// does — startup imports this module at the top.
import './api/jobs/types/index.js';
import './api/generate-answer.js';
import './api/generate-grading-reports.js';
import './api/generate-ms-gs-file.js';
import './api/get-all-files.js';
import './api/get-all-teachers.js';
import './api/get-approved-member-counts.js';
import './api/get-classroom-by-code.js';
import './api/get-classrooms-by-ids.js';
import './api/get-conversations.js';
import './api/get-exam-status.js';
import './api/get-exam-tasks-tree.js';
import './api/get-exams-by-class.js';
import './api/get-exams.js';
import './api/get-master-solutions.js';
import './api/get-my-class-memberships.js';
import './api/get-my-classes.js';
import './api/get-pending-request-counts.js';
import './api/get-roster-for-class.js';
import './api/get-student.js';
import './api/get-students-by-ids.js';
import './api/get-submissions.js';
import './api/get-teacher.js';
import './api/give-feedback.js';
import './api/jobs/get-live-grading-jobs.js';
import './api/jobs/get-live-solution-jobs.js';
import './api/password-reset.js';
import './api/pending-file.js';
import './api/regenerate-classroom-code.js';
import './api/request-to-join-class.js';
import './api/rerun-boundingbox-ocr.js';
import './api/save-additional-info.js';
import './api/set-teacher-grading-kindness.js';
import './api/set-teacher-language.js';
import './api/start-structure-extraction.js';
import './api/student-exam.js';
import './api/submit-app-feedback.js';
import './api/translate-natural-language-to-latex.js';
import './api/update-assignment-proposal.js';
import './api/update-exam-task-content.js';
import './api/update-exam.js';
import './api/update-grading-scale.js';
import './api/update-grammar-error.js';
import './api/update-grammar-fi-settings.js';
import './api/update-grammar-preferences.js';
import './api/update-submission-image-ids.js';
import './api/update-submission-task.js';
import './dummy.js';
